export const INTERCOM_APP_ID = 'jkycbmvz'

export default function () {
  const w = window
  const ic = w.Intercom
  if (typeof ic === 'function') {
    ic('reattach_activator')
    ic('update', window.intercomSettings)
  } else {
    const d = document
    const i = function () {
      // eslint-disable-next-line
      i.c(arguments)
    }
    i.q = []
    i.c = function (args) {
      i.q.push(args)
    }
    w.Intercom = i

    const s = d.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`
    const x = d.getElementsByTagName('script')[0]

    x.parentNode.insertBefore(s, x)
  }

  Intercom.installed = true
}
